import React, { useState } from 'react';
import { SketchPicker } from 'react-color';
import { EditIcon } from './icons';

export const PRESET_COLORS = [
  ['#f44336', 'Rød'], ['#e91e63', 'Rosa'], ['#9c27b0', 'Lilla'], ['#673ab7', 'Fiolett'], ['#3f51b5', 'Indigo'],
  ['#2196f3', 'Blå'], ['#009688', 'Blågrønn'], ['#4caf50', 'Grønn'], ['#8bc34a', 'Lysegrønn'], ['#ffeb3b', 'Gul'],
  ['#ff9800', 'Oransje'], ['#795548', 'Brun'], ['#F8E8D0', 'Lys hud'], ['#E6C2A6', 'Hud'], ['#C8916B', 'Mørk hud'],
  ['#654321', 'Mørkebrun'], ['#2F1B14', 'Nesten svart'],
];

// Klikk på en farge velger den. «Endre farge» åpner fargevelgeren for den
// valgte av «Dine farger» (tidligere åpnet velgeren seg ved hvert klikk).
const Palette = ({ activeColor, customColors, selectedCustom, onPickPreset, onPickCustom, onEditCustom }) => {
  const [editing, setEditing] = useState(false);
  const canEdit = selectedCustom !== null;

  return (
    <div className="palette" role="group" aria-label="Farger">
      <span className="current-color" style={{ background: activeColor }} aria-label="Valgt farge" role="img" />
      <div className="palette-divider" />
      <div className="palette-rows">
        <div className="palette-row">
          <span className="palette-label">Standard</span>
          {PRESET_COLORS.map(([hex, label]) => {
            const selected = selectedCustom === null && hex === activeColor;
            return (
              <button key={hex} className={`swatch${selected ? ' is-selected' : ''}`} style={{ background: hex }}
                aria-label={label} aria-pressed={selected}
                onClick={() => { setEditing(false); onPickPreset(hex); }} />
            );
          })}
        </div>
        <div className="palette-row">
          <span className="palette-label">Dine farger</span>
          {customColors.map((hex, i) => (
            <button key={i} className={`swatch${selectedCustom === i ? ' is-selected' : ''}`} style={{ background: hex }}
              aria-label={`Din farge ${i + 1}`} aria-pressed={selectedCustom === i}
              onClick={() => { setEditing(false); onPickCustom(i); }} />
          ))}
          <button className="edit-color" disabled={!canEdit} aria-expanded={editing}
            title={canEdit ? 'Bland en ny farge i denne ruta' : 'Velg en av «Dine farger» først'}
            onClick={() => setEditing(!editing)}>
            <EditIcon size={15} /> Endre farge
          </button>
        </div>
      </div>
      {editing && canEdit && (
        <>
          <div className="popover-backdrop" onClick={() => setEditing(false)} />
          <div className="color-popover">
            <SketchPicker color={activeColor} disableAlpha presetColors={[]}
              onChange={(color) => onEditCustom(selectedCustom, color.hex)} />
          </div>
        </>
      )}
    </div>
  );
};

export default Palette;
